// extracted by mini-css-extract-plugin
export default {"layoutAvatar":"layoutAvatar_to2GL","contain":"contain_DwLYT","hasError":"hasError_hwVX6"};